import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { FlagsProvider } from "flagged";
import { useDispatch, useSelector } from "react-redux";
import {
  selectShouldFetchUser,
  selectUser,
} from "../../pages/UserProfile/userProfile.selectors";
import flags from "../../flags.json";
import { getUpdatedFeatureFlags } from "../../helpers";
import { EMPTY_STRING, GITHUB_AUTH_FLOW } from "../../constants";
import { Auth } from "aws-amplify";
import { actions } from "../../pages/UserProfile/userProfile.reducers";
import { fetchUserProfileById } from "../../pages/UserProfile/userProfile.actions";

const ID = "id";
const EMAIL = "email";
const AUTHENTICATED = "authenticated";
const { setShouldFetchUser, setIsAuthenticated } = actions;
const { GITHUB, PROVIDER, GITHUB_USER_INFO } = GITHUB_AUTH_FLOW;

const AccessProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { route, authStatus } = useAuthenticator((context) => [
    context.route,
    context.authStatus,
  ]);

  const currentUser = useSelector(selectUser);
  const shouldFetchUser = useSelector(selectShouldFetchUser);
  const provider = sessionStorage.getItem(PROVIDER);
  const githubUser = sessionStorage.getItem(GITHUB_USER_INFO);

  const [domain, setDomain] = useState(EMPTY_STRING);
  const [userId, setUserId] = useState(EMPTY_STRING);
  const [featureFlags, setFeatureFlags] = useState();
  const [shouldAllow, setShouldAllow] = useState(false);

  const handleFetchUser = (sub) => {
    dispatch(setShouldFetchUser(false));
    dispatch(fetchUserProfileById(sub));
  };

  if (provider === GITHUB) {
    const { user } = JSON.parse(githubUser);
    shouldFetchUser && handleFetchUser(user.sub);
  } else {
    Auth.currentAuthenticatedUser()
      .then((res) => shouldFetchUser && handleFetchUser(res.attributes.sub))
      .catch((err) => {
        console.log(err);
        setShouldAllow(true);
      });
  }

  useEffect(() => {
    if (currentUser) {
      setDomain(get(currentUser, EMAIL, EMPTY_STRING).split("@")[1]);
      setUserId(get(currentUser, ID, EMPTY_STRING));
    }
  }, [currentUser]);

  useEffect(() => {
    if (userId || domain) {
      const data = getUpdatedFeatureFlags(flags, userId, domain);
      setFeatureFlags(data);
    }
  }, [setFeatureFlags, userId, domain]);

  useEffect(() => {
    currentUser && featureFlags && setShouldAllow(true);
  }, [currentUser, featureFlags]);

  useEffect(() => {
    dispatch(
      setIsAuthenticated(
        route === AUTHENTICATED || authStatus === AUTHENTICATED
      )
    );
  }, [route, dispatch, authStatus]);

  if (shouldAllow)
    return <FlagsProvider features={featureFlags}>{children}</FlagsProvider>;
};

export default AccessProvider;
